<template>
  <div>
    <b-card>
      <div slot="header">
        <b v-text="title" />
      </div>
      <LoadingSpinner :loading="loading" />
      <b-row v-if="!loading" class="my-2">
        <b-col v-if="finishCheck" cols="12" md="12">
          <b-alert show variant="info">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <b v-html="finishMessage" />
          </b-alert>
        </b-col>
        <b-col cols="12" v-if="!finishCheck || showAdminList">
          <div v-if="items.length">
            <a
              target="_blank"
              v-for="(item, index) in items"
              :key="index"
              class="btn btn-info text-white m-2"
              :href="item.address"
              v-text="pathOr('', ['exam_pack', 'name'], item)"
            />
          </div>
          <b-alert
            v-else
            show
            variant="info"
            class="text-center"
            v-text="'هیچ موردی برای نمایش وجود ندارد'"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";

export default {
  inject: ["researchAzmoonExecutePersonReferenceRepository"],
  components: {
    LoadingSpinner,
  },
  props: {
    title: {
      type: String,
      default: "لیست پرسشنامه‌ها",
    },
    finishCheck: {
      type: Boolean,
      default: false,
    },
    finishMessage: {
      type: String,
      default: "",
    },
    showAdminList: {
      type: Boolean,
      default: false,
    },
    azmoonId: {
      type: [String, Number],
      default: null,
    },
    personCode: {
      type: [String, Number],
      default: null,
    },
    operatorCode: {
      type: [String, Number],
      default: null,
    },
    referenceCode: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    pathOr,
    async getItems() {
      if(!this.azmoonId) return;
      try {
        this.loading = true;
        const response =
          await this.researchAzmoonExecutePersonReferenceRepository.list(
            this.azmoonId,
            this.personCode,
            this.operatorCode,
            this.referenceCode
          );
        this.items = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>